import { ArticleSourceType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';

// Status bar will be visible based on the article type
export const getStatusbarStyles = (articleType: ArticleSourceType) => {
  if (
    [ArticleSourceType.POST, ArticleSourceType.HELP_CENTER, ArticleSourceType.LESSON].includes(
      articleType,
    )
  ) {
    return {};
  }
  return {
    max_height: 500,
    statusbar: false,
  };
};
